import { AppContext } from "@/services/AppContext/appContext";
import { BasicTask } from "@/types";
import { useCallback, useContext, useMemo } from "react";

export const useTasks = () => {
  const { userTasks } = useContext(AppContext);

  const getTaskById = useCallback(
    (id: number | string): BasicTask | undefined => {
      try {
        if (typeof id === "string") {
          id = Number(id); // Using Number to convert string to number
        }

        if (isNaN(id)) {
          throw new Error("Invalid ID: " + id);
        }

        return userTasks.find((task) => task.id === id);
      } catch (error) {
        console.error("Error fetching task by ID:", error);
        return undefined;
      }
    },
    [userTasks]
  );

  // useMemo ensures the returned object is memoized and only recreated when dependencies change
  return useMemo(
    () => ({
      getTaskById,
    }),
    [getTaskById]
  );
};
